import styled from "styled-components";

export const TeamContainer = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
`;

export const MembersContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
